import { FC } from "react";
import FAKOMSvg from "../../public/icons/FAKOM.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const FAKOMIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><FAKOMSvg/></span>;
